import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { ICardHeaderProps, ICardProps } from './interface';
import { Title } from './with-card-header';

export const Card: React.FC<ICardProps> = ({ children, cardProps, testId }) => (
  <Box
    p={2}
    component="section"
    {...cardProps}
    sx={{
      breakInside: 'avoid',
      borderRadius: '8px',
      backgroundColor: '#fff',
      border: '1px solid #E3E3E3',
      position: 'relative',
      ...cardProps?.sx,
    }}
    data-testid={testId}
  >
    {children}
  </Box>
);

export const CardHeader: React.FC<
  ICardHeaderProps & { children: React.ReactNode }
> = ({ children, ...props }) => {
  if (!props.headerActions)
    return (
      <Card {...props}>
        <>
          <Title {...props} />

          {children}
          {props.cardFooter}
        </>
      </Card>
    );

  return (
    <Card {...props}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        gap={1}
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Title {...props} />

        {props.headerActions}
      </Stack>

      {children}

      {props.cardFooter}
    </Card>
  );
};
